import FBTip3Tokens from './FBTip3Tokens';

export default FBTip3Tokens;
